import * as P from "@components/customizing/print/Print.styles";
import { useTabStickyHandler } from "@hook/customizing/print/useTabStickyHandler";
import { useRef, useMemo } from "react";
import { usePrintFaqQuery } from "@hook/customizing/print/usePrintFaqQuery";
import { useRouter } from "next/router";
import { PageRouter } from "@common/pageRouter";
import { usePrintCartItemsQuery } from "@hook/customizing/print/usePrintProductListQuery";

const ESTIMATE_TAB_TITLE = "견적요청";
const ROOT_TITLE = "소량인쇄";

export const PrintTab = () => {
  const router = useRouter();
  const tabHeaderRef = useRef(null);
  const { isSticky } = useTabStickyHandler(tabHeaderRef);

  // FAQ (로딩이 끝난 뒤에만 조회하도록 isReady 전달)
  const { data: faqList } = usePrintFaqQuery(router.isReady);

  // 장바구니 아이템 구독 (react-query)
  const { data: printCartItems = [] } = usePrintCartItemsQuery();

  // 배지용 카운트 (원하는 기준으로 사용)
  const cartItemCount = printCartItems.length; // 서로 다른 상품 개수
  // const cartQtySum = printCartItems.reduce((acc, cur) => acc + (Number(cur.cnt) || 0), 0); // 총 수량 합계

  // "소량인쇄" 하위 탭
  const tabRouter = useMemo(
    () => PageRouter.find((item) => item.title === ROOT_TITLE)?.sub || [],
    []
  );

  // FAQ 없으면 FAQ 탭 제거
  const tabs = useMemo(() => {
    if (!faqList) return tabRouter;
    return faqList.length === 0
      ? tabRouter.filter((tab) => tab.title !== "소량인쇄 FAQ")
      : tabRouter;
  }, [faqList, tabRouter]);

  const onChangeMainTab = (tab) => {
    if (tab?.url && tab.url !== router.pathname) {
      router.push(tab.url);
    }
  };

  return (
    <P.TabContainer ref={tabHeaderRef} isSticky={isSticky}>
      <P.TabHeader>
        {tabs.map((tab) => {
          const isActive = router.pathname === tab?.url;
          const isEstimateTab = tab?.title === ESTIMATE_TAB_TITLE;

          return (
            <P.TabItem
              key={tab?.url || tab?.title}
              active={isActive}
              onClick={() => onChangeMainTab(tab)}
              style={{ position: "relative" }}
            >
              {tab?.title}

              {/* 배지: 장바구니에 담긴 상품 개수 표시 */}
              {isEstimateTab && cartItemCount > 0 && (
                <span
                  style={{
                    marginLeft: 8,
                    display: "inline-block",
                    minWidth: 18,
                    padding: "0 6px",
                    height: 18,
                    lineHeight: "18px",
                    borderRadius: 9,
                    fontSize: 12,
                    textAlign: "center",
                    background: "#ef4444",
                    color: "#fff",
                    verticalAlign: "middle",
                  }}
                >
                  {cartItemCount}
                </span>
              )}

              {/*
              // 만약 총 수량 합계를 보여주고 싶다면 위 배지 대신 아래로 교체
              {isEstimateTab && cartQtySum > 0 && (
                <span style={...sameStyle}>{cartQtySum}</span>
              )}
              */}
            </P.TabItem>
          );
        })}
      </P.TabHeader>
    </P.TabContainer>
  );
};

export default PrintTab;
